import Base64 from "@repo/utils/Base64";
import FullName from "@repo/utils/FullName";
import UZod from "@repo/utils/UZod";
import { z } from "zod";

type User = z.infer<typeof User.zodSchema>;

namespace User {
  export type Id = `u_${string}`;

  export namespace Id {
    export const is = (id: string): id is Id => id.startsWith("u_");
    export const zodSchema = () => UZod.predicate(is, "Invalid user id");
  }

  export const zodSchema = z.object({
    id: Id.zodSchema(),
    email: z.string().email(),
    name: FullName.zodSchema().optional(),
    pfpUrl: z.string().url().optional(),
    phone: z.string().optional(),
  });

  export type Params = Partial<
    {
      pfpBase64: Base64;
      pfpMimeType: string;
    } & Omit<User, "id" | "pfpUrl">
  >;
}

export default User;
